import React, { useState, useEffect } from 'react'
import { Form, Radio, Checkbox } from 'antd'
import * as FIELD_LABEL from 'constant/form-labels'
import * as FIELD_NAME from 'constant/form-item-names'

const Email = () => {
  const [emails, setEmail] = useState()

  useEffect(() => {
    setEmail(false)
  }, [])

  const handleUpdate = (prevValues, currentValues) => prevValues.published !== currentValues.published

  return (
    <>
      <Form.Item
        noStyle
        shouldUpdate={handleUpdate}
      >
        {({ getFieldValue }) => {
          const published = getFieldValue(FIELD_NAME.PUBLISHED)
          return (published && getRadio(setEmail))
        }}

      </Form.Item>
      {emails && <>
        <Form.Item
          name={FIELD_NAME.FORCE_SEND_EMAILS}
          valuePropName='checked'
        >
          <Checkbox>Bypass users email preference</Checkbox>
        </Form.Item>
      </>
      }

    </>
  )
}

const getRadio = (setEmail) => (
  <>
    <span>{FIELD_LABEL.SEND_EMAILS}</span>
    <Form.Item
      name={FIELD_NAME.SEND_EMAILS}
    >
      <Radio.Group initialValues='false'>
        <Radio.Button
          defaulChecked
          onClick={(e) => setEmail(false)}
          value='false'
        >No</Radio.Button>
        <Radio.Button
          onClick={(e) => setEmail(true)}
          value='true'
        >Yes</Radio.Button>
      </Radio.Group>
    </Form.Item>
  </>)

export default Email
